import React, { useEffect } from 'react';
import { useSpring } from 'react-spring';
import { Feature, Flagged, Stable } from 'components/Flagged';
import { useFlags } from 'gatsby-plugin-launchdarkly';
import { Flags } from 'utils/constants/featureFlags';
// local imports
import * as S from './styles';

type EligibleContentProps = {
  onRender: () => void;
};

export const ProgressBar = () => {
  const props = useSpring({
    from: { width: '0%' },
    width: '100%',
    delay: 400,
  });
  return (
    <S.ProgressBar>
      {/* @ts-ignore */}
      <S.Inner style={props} />
    </S.ProgressBar>
  );
};

export const EligibleContent = ({ onRender }: EligibleContentProps) => {
  useEffect(() => {
    onRender();
  }, []);
  const flags = useFlags();
  const covidQuestionaireFlag = flags[Flags.CovidQtyAndScreener];
  return (
    <S.EligibleContent>
      <Flagged flag={covidQuestionaireFlag}>
        <Feature>We are redirecting you to checkout…</Feature>
        <Stable>You are eligible. We are redirecting you to checkout…</Stable>
      </Flagged>
      <ProgressBar />
    </S.EligibleContent>
  );
};

export default EligibleContent;
